module.exports = {
  defaultTitle: 'Robert Foltz',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'Robert Foltz',
  url: 'https://robertfoltz.com',
  defaultDescription: `I'm Robert, and I'm a full-stack developer`,
  socialLinks: {
    twitter: 'https://www.twitter.com/suavesofa',
    github: 'https://github.com/rfoltz',
    linkedin: 'https://www.linkedin.com/in/robert-foltz-593b6163/',
  },
  googleAnalyticsID: '',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    twitter: '@suavesofa',
  },
  foundingDate: '2014',
};
